import React, { useContext, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import MapContext from 'components/MapComponent/MapContext';
import {
  defaultMapCenter,
  defaultMapMinZoom,
  makeFeature,
  makeVectorLayer,
} from 'components/MapComponent/constants';
import { resetFoundLayerAction } from 'store/actions/layers';

export const DrawWKT: React.FC = (): null => {
  const {
    wktATE,
    foundWkt,
    currAteCity,
    currAteVC,
    currAteRegion,
    foundInfoSoato,
  } = useAppSelector((state) => state.layers);
  const { statisticsData } = useAppSelector((state) => state.mainPage);
  const { map } = useContext(MapContext);
  const dispatch = useAppDispatch();
  const statWkt = statisticsData?.wkt;

  const createWkt = (
    wkt: string[],
    map: any,
    needZoom: boolean,
    needGroupZoom?: boolean
  ) => {
    if (!map || !wkt[0]) return;
    const feature = wkt.map((item) => makeFeature(item));
    let vectorLayer = makeVectorLayer(feature);

    const onlyRegionSelect =
      currAteRegion && !currAteCity?.id && !currAteVC?.id;

    map.addLayer(vectorLayer);

    if (needZoom) {
      if (onlyRegionSelect) {
        map.getView().setZoom(defaultMapMinZoom);
        map.getView().setCenter(defaultMapCenter);
      } else {
        let extent = feature[0].getGeometry();
        map.getView().fit(extent, { size: map.getSize() });
      }
    }
    if (needGroupZoom && vectorLayer) {
      const layerExtent = vectorLayer.getSource()?.getExtent();
      layerExtent && map.getView().fit(layerExtent, { size: map.getSize() });
    }

    return () => {
      vectorLayer.getSource()?.clear();
    };
  };

  //geometry
  useEffect(() => {
    if (!wktATE) return;
    const lastSoato =
      currAteVC?.soato || currAteCity?.soato || currAteRegion?.soato;
    if (lastSoato !== foundInfoSoato && wktATE) {
      dispatch(resetFoundLayerAction());
    }

    return createWkt([wktATE], map, true);
  }, [map, wktATE]);

  useEffect(() => {
    if (!foundWkt) return;
    return createWkt([foundWkt], map, false);
  }, [map, foundWkt]);

  useEffect(() => {
    if (!statWkt || !statWkt.length) return;
    const wkt = statWkt.map((i) => i.wkt);
    return createWkt(wkt, map, false, true);
  }, [map, statWkt]);

  return null;
};
